<template>
  <div class="pa-4">
    <v-row>
      <v-col cols="12" sm="6">
        <div class="d-flex flex-row mb-2">
          <span class="headline">個人資訊</span>
          <v-spacer></v-spacer>
          <v-btn
            v-if="!isSuperAdmin"
            depressed
            dark
            color="blue"
            @click="$refs.editProfileDialog.show(userProfile)"
          >編輯</v-btn>
        </div>
        <v-card outlined>
          <v-card-text>
            <v-row>
              <v-col cols="2">姓名</v-col>
              <v-col cols="10" v-text="userProfile.name" class="black--text"></v-col>
              <v-col cols="2">手機</v-col>
              <v-col cols="10" v-text="userProfile.phone" class="black--text"></v-col>
              <v-col cols="2">密碼</v-col>
              <v-col cols="10 t" class="black--text overline">●●●●●●●</v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <dialog-edit-user-profile ref="editProfileDialog" @done="getProfile"></dialog-edit-user-profile>
  </div>
</template>

<script>
import DialogEditUserProfile from "./DialogEditUserProfile";

export default {
  components: {
    DialogEditUserProfile
  },
  data: () => ({
    userProfile: {}
  }),
  methods: {
    async getProfile() {
      if (this.isSuperAdmin) {
        this.userProfile = {
          name: this.$my.getName(),
          phone: this.$my.getPhone()
        };
      } else {
        let response = await this.$ajax.post(
          `${this.$config.apiUrl}/${this.$my.getClinic()}/search/user`,
          { phone: this.$my.getPhone() }
        );
        this.userProfile = response.data[0];
      }
      //console.log("response:" + JSON.stringify(response.data));
    }
  },
  computed: {
    isSuperAdmin() {
      return this.$my.getPermission() === "role_superadmin";
    }
  },
  mounted() {
    this.getProfile();
  }
};
</script>
